export interface SamlLoginProvider {
    samlLoginProviderExists: boolean;
    loginButtonText?: string;
    providers?: SamlLoginProviderOption[];
}

export interface SamlLoginProviderOption {
    providerKey: string;
    name?: string;
    loginButtonText?: string;
    isDefault?: boolean;
}

export const samlLoginOptionStorageKey = "acxSamlLoginOption";

// undefined = not yet determined, null = no SAML provider configured.
// The cached value lets returning users render the correct form on the
// first paint instead of flashing username/password before the SSO check.
export function readCachedSamlLoginOption():
    | SamlLoginProvider
    | null
    | undefined {
    try {
        const cached = localStorage.getItem(samlLoginOptionStorageKey);
        return cached ? JSON.parse(cached) : undefined;
    } catch {
        return undefined;
    }
}

export function writeCachedSamlLoginOption(provider: SamlLoginProvider | null) {
    try {
        localStorage.setItem(
            samlLoginOptionStorageKey,
            JSON.stringify(provider),
        );
    } catch {
        // Best-effort cache; losing it only costs a loader on next visit.
    }
}

// AuthorizeService wipes localStorage when silent sign-in fails, to drop
// stale oidc state before an interactive login. Route that wipe through
// here so the login form still knows which variant (SSO vs
// username/password) to render on its first paint.
export function clearLocalStoragePreservingSamlLoginOption() {
    const cached = localStorage.getItem(samlLoginOptionStorageKey);
    localStorage.clear();
    if (cached !== null) {
        localStorage.setItem(samlLoginOptionStorageKey, cached);
    }
}
